import { render, staticRenderFns } from "./VFormImageInput.vue?vue&type=template&id=af8b0f4e&scoped=true&"
import script from "./VFormImageInput.vue?vue&type=script&lang=js&"
export * from "./VFormImageInput.vue?vue&type=script&lang=js&"
import style0 from "./VFormImageInput.vue?vue&type=style&index=0&id=af8b0f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8b0f4e",
  null
  
)

export default component.exports